import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";

import { LookupForm } from "@/components/lookup-form";
import { QueryState } from "@/components/query-state";
import { PoolTable } from "@/features/pools/PoolTable";
import { useGetPoolsByPair } from "@/generated/api/pairs/pairs";
import type { GetPoolsByPairParams } from "@/generated/api/model";

export const Route = createFileRoute("/pairs")({ component: Pairs });

const FIELDS = [
    // The bot keys pairs by unit id, not by the display names the pools show.
    { name: "asset_a", label: "Asset A", placeholder: "lovelace" },
    { name: "asset_b", label: "Asset B", placeholder: "policy id + hex asset name" },
] as const;

function Pairs() {
    const [pair, setPair] = useState<GetPoolsByPairParams | null>(null);

    return (
        <div className="space-y-4">
            <LookupForm fields={FIELDS} onSubmit={setPair} />
            {pair && <PairPools pair={pair} />}
        </div>
    );
}

function PairPools({ pair }: { pair: GetPoolsByPairParams }) {
    const pools = useGetPoolsByPair(pair);
    return (
        <QueryState
            query={pools}
            isEmpty={(data) => data.pools.length === 0}
            emptyMessage={`No pool trades ${pair.asset_a}/${pair.asset_b}.`}
        >
            {(data) => <PoolTable pools={data.pools} label="Pair pools" />}
        </QueryState>
    );
}
